import { EvtHeader } from "components/header";
import React from "react";
import { useParams } from "react-router-dom";
import QuestionForm from "../form";

const UpdateQuestion = () => {
  const { questionId } = useParams();

  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Update Question" />
      <div className="p-6 max-w-2xl">
        <QuestionForm questionId={questionId} />
      </div>
    </div>
  );
};

export default UpdateQuestion;
